import React, { useState, useEffect } from "react";
import { Card, CardHeader, CardTitle, CardBody, Row, Col } from "reactstrap";

import api from "../../../../../services/api";
import useCancelableFetch from "../../../../../hooks/useCancelableFetch";
import ChartAreaOneLine from "../../../../../components/ChartAreaOneLine";
import { useCompanies } from "../../../../../hooks/companies"; // Importa o hook useCompanies

export default function ChartFretePorNf({
  deferLoad = false,
  onRegisterFetch,
}) {
  const { empresa, transportadora, arrayParams } = useCompanies(); // Obtém as seleções de empresa e transportadora

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  async function loadCharts() {
    const controller = createController();
    try {
      setLoading(true);

      const params = {};

      if (arrayParams.embarcadores) {
        params.embarcadores = arrayParams.embarcadores;
      }

      if (arrayParams.transportadoras) {
        params.transportadoras = arrayParams.transportadoras;
      }

      const response = await api.get("/dashboard/custo/frete-por-notafiscal", {
        params,
        signal: controller.signal,
      });

      if (response.status === 200) {
        setData(response.data);
      }
    } catch (error) {
      if (error && error.code === "ERR_CANCELED") {
        // aborted
      } else {
        console.error("Erro ao carregar dados:", error);
      }
    } finally {
      setLoading(false);
    }
  }

  const { createController } = useCancelableFetch(30000);

  useEffect(() => {
    if (onRegisterFetch) onRegisterFetch(loadCharts);
    if (!deferLoad) {
      if (empresa) loadCharts(); // Carrega os gráficos quando empresa ou transportadora mudar
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [empresa, transportadora]); // Adiciona empresa e transportadora como dependências

  return (
    <Card
      style={{ boxShadow: "0px 1px 20px 0px rgb(0, 0, 0)" }}
      className="card-chart"
    >
      <CardHeader>
        <Row style={{ alignItems: "center" }}>
          <Col>
            <h4>Frete sobre NF</h4>
            <CardTitle>Percentual de frete sobre o valor da NF</CardTitle>
          </Col>
        </Row>
      </CardHeader>
      <CardBody>
        <ChartAreaOneLine
          data={data}
          grid="rgba(245,54,92, 0.1)"
          lineColor="#f5365c"
          dataKey="valor"
          name="percentual do frete"
          measure="%"
          yAxisWidth={60}
          loading={loading}
          idLinha="freteNf"
        />
      </CardBody>
    </Card>
  );
}
